import {IUserStatistic} from '@/stores/ItemsStore/ItemsStore.types';

import {MONTH_VARIANTS} from '@/constants';
import {DayMonthDateValidationRule, StatisticValidationRule} from '@/resources';
import {FrontendError} from '@/services/ErrorService/FrontendError';
import {StatisticItemValidationType} from '@/types';
import {ValidationUtils} from '@/utils/ValidationUtils';

export const validateDayMonthDate = (
  statistic: IUserStatistic,
  rule: StatisticValidationRule,
  logError: (error: FrontendError) => void,
): string | null => {
  if (!ValidationUtils.isValidationRule<DayMonthDateValidationRule>(rule, StatisticItemValidationType.DayMonthDate)) {
    return null;
  }

  let statisticValue = statistic.value;
  const ruleValue = rule.value;
  const date = new Date(statisticValue);
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();

  if (
    Number.isNaN(day) ||
    Number.isNaN(month) ||
    Number.isNaN(year) ||
    !ValidationUtils.isStringValue(statisticValue) ||
    !ValidationUtils.isCurrentYearValue(year)
  ) {
    // логируем невалидное значение даты
    const error = FrontendError.createNotDateValueError(statistic.metricDesc, statisticValue);
    logError(error);

    return null;
  } else if (ruleValue && MONTH_VARIANTS[month]) {
    const monthValue = MONTH_VARIANTS[month][2].toLowerCase();
    statisticValue = `${day} ${monthValue}`;
  }

  return statisticValue;
};
